import { useQuery } from '@tanstack/react-query';
import { getScheduledCustomSurveyById } from '../../api/queries';

export const useGetScheduledCustomSurveyById = (
  teamId: number,
  surveyId: number,
  isEnabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['scheduledCustomSurvey', teamId, surveyId],
    queryFn: () => getScheduledCustomSurveyById(teamId, surveyId),
    enabled: !!teamId && !!surveyId && isEnabled,
  });
};
